import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'
import { maskMoney } from 'util/masks'

const GrayBox: React.FC<{ icon: string, title: string, content: any }> = ({ icon, title, content }) => {
  return (
    <div className="gray-box">
      <div className="icon">
        <div>
          <i className={`fas fa-${icon}`} />
          <p>{ title }</p>
        </div>
      </div>
      <div className="box-content">
        <p>{ content }</p>
      </div>
    </div>
  )
}

const PartnerInfo: React.FC = () => {
  const { partner } = useSelector((state: ApplicationState) => state.partnerReducer)

  if (!partner) return null

  return (
    <div className="panel cash-info  grow margin-left-24">

      <div className="row">
        <div className="col-6">
          <GrayBox icon="cash-register" title="CAIXA" content={maskMoney(partner.balance || 0)} />
        </div>
        <div className="col-3 padding-lr-16">
          <GrayBox icon="shopping-cart" title="Vendas" content={partner.sales} />
        </div>
        <div className="col-3">
          <GrayBox icon="eye" title="Visualizações" content={partner.views} />
        </div>
      </div>
      <div className="row margin-top-16">
        <div className="col-6" style={{ paddingRight: 8 }}>
          <NavLink to={`/panel/partner/${partner.id}/product`} >
            <GrayBox icon="hamburger" title="PRODUTOS" content={partner.products} />
          </NavLink>
        </div>
        <div className="col-6" style={{ paddingLeft: 8 }}>
          <GrayBox icon="shopping-cart" title="PEDIDOS" content={partner.sales} />
        </div>
      </div>

    </div>
  )
}

export default PartnerInfo
